export default function toHumanReadableFilesize(
    size: number, 
    numberOfDecimals: number = 2
) 
{
    const suffixes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return !size ? '0 Bytes' : (size / Math.pow(1024, i)).toFixed(numberOfDecimals) + ' ' + suffixes[i];
}